const HEADER_HEIGHT = 100;
const POLL_INTERVAL_MS = 50;
const MAX_ATTEMPTS = 30;

function getScrollTarget(path) {
  if (path.includes('/settings')) {
    return document.querySelector('.settings-right-content');
  }

  return (
    document.querySelector('.employee-management-content') ||
    document.querySelector('.overview-main') ||
    document.querySelector('main')
  );
}

function scrollToElement(element) {
  const rect = element.getBoundingClientRect();
  const currentScroll = window.scrollY || window.pageYOffset || 0;
  const targetScroll = rect.top + currentScroll - HEADER_HEIGHT;

  if (targetScroll > 50) {
    window.scrollTo({ top: targetScroll, behavior: 'smooth' });
  }

  return true;
}

function clearTutorialNavigationFlag() {
  sessionStorage.removeItem('tutorialNavigation');
}

export function scrollToTutorialContent(path) {
  const tryScroll = () => {
    const element = getScrollTarget(path);
    if (!element) return false;
    return scrollToElement(element);
  };

  const finish = (scrolled) => {
    if (!scrolled) {
      window.scrollTo({ top: 200, behavior: 'smooth' });
    }

    setTimeout(clearTutorialNavigationFlag, 500);
  };

  requestAnimationFrame(() => {
    if (tryScroll()) {
      finish(true);
      return;
    }

    let attempts = 0;
    const interval = setInterval(() => {
      attempts += 1;

      if (tryScroll()) {
        clearInterval(interval);
        finish(true);
        return;
      }

      if (attempts >= MAX_ATTEMPTS) {
        clearInterval(interval);
        finish(false);
      }
    }, POLL_INTERVAL_MS);
  });
}
